// Phase H+1 Mini-Wave 5 · POST-FIX role-matrix PRD V10 compliance.
// Route-level guard per placeholder shell V12 admin-only (SEO & Integrazioni, ecc).
// Zero-touch: componente nuovo additivo · nessuna modifica a ProtectedRoute core.
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";
import { isAdminRole } from "@/data/v12_user_nav";

/**
 * V12AdminOnlyRoute · wrappa route V12 admin-only.
 * - Se `user` assente → redirect `/` (landing + login flow).
 * - Se `user.role` non in `admin|super_admin` → redirect `/app/dashboard` + warn.
 * - Append `?blocked=admin_only` sul redirect per permettere al dashboard di
 *   mostrare un toast "Accesso riservato ad amministratori".
 */
export default function V12AdminOnlyRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div
                className="min-h-screen v12-bg flex items-center justify-center"
                data-testid="v12-admin-only-route-loading"
            >
                <span className="text-xs text-neutral-500 tracking-wide">
                    Caricamento…
                </span>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/" replace state={{ from: location.pathname }} />;
    }

    if (!isAdminRole(user.role)) {
        // eslint-disable-next-line no-console
        console.warn(
            `[V12AdminOnlyRoute] Access denied for role='${user.role}' on '${location.pathname}'. Redirecting to /v2/dashboard.`,
        );
        return (
            <Navigate
                to="/app/dashboard?blocked=admin_only"
                replace
            />
        );
    }

    return children;
}
